module.exports = __webpack_public_path__ + "img/品牌图.df31f2b8.png";